import React, { useContext, useState, useMemo, useEffect } from "react";
import Swal from 'sweetalert2';

import templateProduccionContext from "../../context/templateProduccionContext/templateProduccionContext";
import activoContext from "../../context/activoContex/activoContex";

import TareasSubtabla from "../tareasSubtabla/TareasSubtabla";

import { estructuraTarea } from "../../utils/estructuras";

import './AbmTemplatesProduccion.css';

const AbmTemplatesProduccion = ({ templateToEdit = {}, setShowABM, setTemplateToEdit }) => {

    const isEditing = Object.keys(templateToEdit).length > 0;

    const [template, setTemplate] = useState(isEditing
        ? {
            ...templateToEdit,
            tareas: templateToEdit.tareas?.length > 0
                ? [...templateToEdit.tareas.map(t => ({
                    value: t.codTarea || t.value || '',
                    label: t.name || t.label || '',
                    name: t.name || '',
                    id: t.id || '',
                    taskDescrp: t.taskDescrp || '',
                    activo: t.codActivo ? {
                        id: t.activoIDRef || '',
                        value: t.codActivo,
                        label: t.activoNombre || t.codActivo
                    } : null,
                    cargaTiempo: t.cargaTiempo || '',
                    unidadMedida: t.unidadMedida || '',
                    horasCarga: t.horasCarga || ''
                })), { ...estructuraTarea }]
                : [{ ...estructuraTarea }]
        }
        : { codTemplate: '', name: '', tareas: [{ ...estructuraTarea }] }
    );

    const [tablaSeleccionada, setTablaSeleccionada] = useState('tareas');
    const { agregarTemplateProduccion, modificarTemplateProduccion, actualizarTemplatesProduccionList, templatesProduccionList } = useContext(templateProduccionContext);
    const { activoList, obtenerActivosAsOptions } = useContext(activoContext);
    const [lightweightActivos, setLightweightActivos] = useState(null);

    useEffect(() => {
        if (!activoList && !lightweightActivos) {
            obtenerActivosAsOptions('habilitadoProduccion').then(data => {
                if (data) setLightweightActivos(data);
            });
        }
    }, [activoList]);

    const optionsActivosProduccion = useMemo(() => {
        const source = activoList
            ? activoList.filter(a => a.habilitadoProduccion === true)
            : (lightweightActivos || []);
        return source.map(a => ({
            value: a.name,
            label: `${a.codActivo} - ${a.name}`,
            activoID: a._id,
            activoCod: a.codActivo
        }));
    }, [activoList, lightweightActivos]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTemplate({ ...template, [name]: value });
    };

    const handleSave = async () => {
        if (!template.codTemplate || template.codTemplate.trim() === '') {
            Swal.fire({
                title: 'Complete el codigo del template',
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }

        if (!template.name || template.name.trim() === '') {
            Swal.fire({
                title: 'Complete el nombre del template',
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }

        // Filtrar tareas vacías antes de guardar
        const templateToSave = {
            ...template,
            tareas: template.tareas
                .filter(t => t.value && t.value !== '' && t.label && t.label !== '')
                .map(t => ({
                    value: t.value,
                    label: t.label,
                    codTarea: t.value,
                    name: t.name || t.label,
                    id: t.id || '',
                    taskDescrp: t.taskDescrp || '',
                    codActivo: t.activo?.value || '',
                    activoNombre: t.activo?.label || '',
                    activoIDRef: t.activo?.id || '',
                    cargaTiempo: t.cargaTiempo || '',
                    unidadMedida: t.unidadMedida || '',
                    horasCarga: t.horasCarga || ''
                }))
        };

        if (isEditing) {
            const res = await modificarTemplateProduccion(templateToSave);
            if (res) {
                Swal.fire({
                    title: 'Se actualizo el template correctamente',
                    icon: 'success',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                setTemplateToEdit({});
                setShowABM(true);
                actualizarTemplatesProduccionList();
            }
        } else {
            const res = await agregarTemplateProduccion(templateToSave);
            if (res === 'DUPLICATEKEY') {
                Swal.fire({
                    title: 'Ya existe un template con ese codigo',
                    icon: 'error',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                return;
            } else if (res) {
                Swal.fire({
                    title: 'Se guardo un nuevo template',
                    icon: 'success',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                setTemplateToEdit({});
                setShowABM(true);
                actualizarTemplatesProduccionList();
            } else {
                Swal.fire({
                    title: 'No se pudo crear el template',
                    icon: 'error',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        }
    };

    const handleClickCancel = () => {
        Swal.fire({
            title: 'Esta seguro que desea cancelar?',
            showDenyButton: true,
            confirmButtonText: 'Si, Cancelar',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                setShowABM(true);
                setTemplateToEdit({});
            }
        });
    };

    return (
        <div className="templateProduccionDiv">
            <div className="templateProduccionForm">
                <div className="templateProduccionFormHeader">
                    <div className="inputGroup" id="codigoInputGroup">
                        <label>Codigo</label>
                        <input
                            disabled={isEditing}
                            name="codTemplate"
                            value={template.codTemplate}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="inputGroup" id="descripcionInputGroup">
                        <label>Nombre</label>
                        <input
                            name="name"
                            value={template.name}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="tablasHijasDiv">
                    <div className="opcionesHijasDiv">
                        <button
                            className={tablaSeleccionada === 'tareas' ? 'opcionHijaBtn selected' : 'opcionHijaBtn'}
                            onClick={() => setTablaSeleccionada('tareas')}
                        >
                            Tareas
                        </button>
                    </div>

                    {tablaSeleccionada === 'tareas' && (
                        <TareasSubtabla
                            tareas={template.tareas}
                            setState={setTemplate}
                            tablaSeleccionada={tablaSeleccionada}
                            tipo="tareaTemplate"
                            optionsActivosProduccion={optionsActivosProduccion}
                            templatesList={templatesProduccionList || []}
                        />
                    )}
                </div>

                <div className="functionsDiv">
                    <button className="saveProcBtn" onClick={handleSave}>
                        {isEditing ? 'Guardar cambios' : 'Guardar'}
                    </button>
                    <button className="cancelProcBtn" onClick={handleClickCancel}>
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AbmTemplatesProduccion;
